import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { type Product } from '../../shared/types';
import { type ProductDetailContext } from '../types/types';

function useProduct(): Product {
    const { product } = useFragmentContext<ProductDetailContext>();

    return product;
}

export { useProduct };
